// extracted by mini-css-extract-plugin
export default {"modalTop":"FeeInfo_modalTop__3uUdi"};